export default __webpack_public_path__ + "static/media/university-cologne.94358f72.jpg";